export const CategoriesTypes = {
    GET_CATEGORIES: "GET_CATEGORIES",
    GET_CLEANER_CATEGORIES: "GET_CLEANER_CATEGORIES",
    CLEAR_CLEANER_CATEGORIES: "CLEAR_CLEANER_CATEGORIES",
}